/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { UserProfile } from "@microsoft/shifts-models-data";
import { UserInfo } from "@microsoft/shifts-models-view";

import { IUserProfileMapper } from "./IUserProfileMapper";

/**
 * The interface for cross-location team mapper.
 */
export class UserProfileMapper implements IUserProfileMapper {
    /**
     * Maps users profiles data model to users info view model.
     * @param users The users profiles data models.
     * @returns The users info view models.
     */
    public toUsersInfo(users: UserProfile[]): UserInfo[] {
        return users.map(user => ({
            email: user.userPrincipalName,
            id: user.id,
            name: user.displayName
        }));
    }
}
